export const FILTER_CATEGORIES = [
  {
    key: 'event',
    label: 'Event',
    values: ['Street protest', 'Police brutality', 'Lethal Violence', 'Evictions', 'Other'],
  },
  {
    key: 'theme',
    label: 'Theme',
    values: ['Right to the City & Right to Housing', 'Racial Justice & Indigenous Rights', 'Environmental Justice & Climate Crisis', 'Women Rights & LGBTQ+ Struggles', 'Democratic Representation & Press Freedom', 'Citizenship & Human Rights', 'Other'],
  },
  {
    key: 'actors',
    label: 'Actors',
    values: ['Activists & Protest Movements', 'Residents, Relatives & Community Members', 'Police', 'Unions', 'Students', 'Media'],
  },
  {
    key: 'videoType',
    label: 'Type of video',
    values: ['Protest Documentation', 'Eyewitness Video', 'Public Speech and Interview', 'Other'],
  },
  {
    key: 'avquality',
    label: 'Audio-visual quality',
    values: ['Low', 'Medium', 'High'],
  },
  {
    key: 'videoLength',
    label: 'Video length',
    values: ['0:00-2:00', '2:00-5:00', '5:00-10:00', '10:00 and more'],
  },
  {
    key: 'viewCount',
    label: 'View count',
    values: ['0-500', '501 - 2000', '2000 - 5000', '5000 - 10000', '10000 and more'],
  },
  {
    key: 'producer',
    label: 'Producer',
    values: ['MIC', 'CMI-Rio', 'Mariachi', 'Midia Ninja', 'Eyewitness (Anonymous)', 'Projetação', 'Coletivo Carranca', 'Rio na Rua', 'Ocupa Camera', 'Linha Frente', 'Coletivo Sagaz', 'Central de Video Ativismo', 'Linha Frente', 'Tactica Gedai', 'Ocupa Golfe', 'Midia1508', '2V', 'Movimento Chega de Descaso', 'PRETO Filmes', 'ANFIP'],
  },
  
];
